export const backendHost = process.env.REACT_APP_BACKEND_URL;
export const axiosConfig = {
  headers: {
      "Access-Control-Allow-Origin": process.env.REACT_APP_FRONTEND_URL,
  }
};